export const quranBs = {
  landing: {
    badge: 'Kur’an je sada otvoren za sve',
    titleLine1: 'Kur’an za svakoga.',
    titleGradient: 'Čitaj. Slušaj. Izučavaj.',
    subtitle:
      'Cijeli Kur’an na arapskom, s prijevodom Besima Korkuta i engleskim prijevodom. Besplatno, bez prijave, na svakom uređaju. Pretraži riječ, prebroji je kroz cijeli Kur’an i slušaj ajet po ajet.',
    appNote: 'Za hifz s AI-jem, audio bez interneta i vaktiju, preuzmi aplikaciju.',
    daily: 'Ajet dana',
    listen: 'Preslušaj',
    study: 'Izučavaj ajet',
    studyEyebrow: 'Kur’an na Deenly',
    studyTitle: 'Ne samo čitaj. Izučavaj.',
    studySubtitle: 'Alati koji ti pomažu da razumiješ šta čitaš, besplatni za svakoga.',
    cards: [
      { to: '/quran/', icon: 'solar:book-2-linear', title: 'Čitaj i slušaj', body: 'Svih 114 sura, arapski tekst i dva prijevoda, šest učača. Player prati ajet koji se uči, čak i sa zaključanog ekrana.', cta: 'Otvori Kur’an' },
      { to: '/quran/tafsir/', icon: 'solar:notebook-bookmark-linear', title: 'Tefsir svakog ajeta', body: 'Šta ajet znači? Objašnjenje svih 6.236 ajeta iz tefsira El-Muhtesar, na bosanskom i u arapskom originalu, s izvorom i citatom.', cta: 'Otvori tefsir' },
      { to: '/quran/search/', icon: 'solar:magnifer-linear', title: 'Pretraži po riječi ili smislu', body: 'Nađi ajet po riječi, imenu sure ili referenci poput 2:255. Ili opiši temu i AI pronađe ajete po značenju.', cta: 'Pretraži Kur’an' },
      { to: '/quran/2/255/', icon: 'solar:square-academic-cap-linear', title: 'Riječ po riječ', body: 'Dodirni bilo koju arapsku riječ: njen korijen, gramatika i koliko je puta u Kur’anu. Iz korijena prati jedan pojam kroz cijeli Kur’an.', cta: 'Probaj na Ajetul-kursiji' },
    ],
  },
  nav: {
    home: 'Deenly početna',
    quran: 'Kur’an',
    label: 'Kur’an navigacija',
    read: 'Čitaj',
    search: 'Pretraga',
    words: 'Kur’an u brojevima',
    tafsir: 'Tefsir',
    roots: 'Korijeni',
    chronology: 'Hronologija',
    switchLanguage: 'Switch to English',
  },
  common: {
    close: 'Zatvori',
    error: 'Nešto nije u redu. Pokušaj ponovo za trenutak.',
    notFound: 'Ovaj ajet ne postoji.',
    breadcrumbs: 'Putanja',
    pagination: 'Prethodno i sljedeće',
    loadMore: 'Učitaj još',
  },
  translation: {
    de: 'Njemački · Bubenheim i Elyas',
    nl: 'Holandski · Centar Rowwad',
    fr: 'Francuski · Rachid Maach',
    bs: 'Bosanski · Besim Korkut',
    en: 'English · Saheeh International',
  },
  quick: {
    label: 'Najčitanije',
    ayatulKursi: 'Ajetul-kursija',
    lastOfBaqarah: 'Amenerresulu',
  },
  index: {
    badge: 'Otvoreno za sve · besplatno · bez prijave',
    title: 'Kur’an za svakoga',
    subtitle:
      'Svih 114 sura na arapskom, s prijevodom Besima Korkuta i engleskim prijevodom. Slušaj ajet po ajet, pretražuj po riječi ili značenju i izučavaj svaku riječ.',
    stats: [
      { label: 'Sura', value: '114' },
      { label: 'Ajeta', value: '6.236' },
      { label: 'Jezika', value: '3' },
      { label: 'Učača', value: '6' },
    ],
    wordsTitle: 'Koliko puta Kur’an spominje…?',
    wordsBody:
      'Ukucaj bilo koju riječ (na arapskom, bosanskom ili engleskom) i za sekundu vidiš koliko se puta pojavljuje, u kojim surama i ajetima. Uporedi dvije riječi i otkrij Kur’an iz novog ugla.',
    wordsCta: 'Otvori Kur’an u brojevima',
    surahsTitle: 'Sve sure',
    surahsSubtitle: 'Pretraži po imenu, značenju ili broju.',
    filterLabel: 'Filtriraj sure',
    filterPlaceholder: 'npr. Jasin, Pećina, 18…',
    filterRevelation: 'Mjesto objave',
    filterAll: 'Sve',
    noMatch: 'Nijedna sura ne odgovara pretrazi.',
  },
  surah: {
    meccan: 'Mekanska',
    medinan: 'Medinska',
    ayahCount: '{n} ajet | {n} ajeta',
    juz: 'Džuz {n}',
    listen: 'Preslušaj suru',
    previous: 'Prethodna sura',
    next: 'Sljedeća sura',
  },
  ayah: {
    actions: 'Akcije za {ref}',
    listen: 'Preslušaj {ref}',
    copy: 'Kopiraj ajet',
    save: 'Sačuvaj u Radnu sobu',
    saved: 'Sačuvano u Zbirku',
    copied: 'Kopirano',
    share: 'Podijeli',
    study: 'Izučavaj {ref}',
    sajdah: 'Sedžda',
  },
  ayahPage: {
    eyebrow: 'Ajet',
    inContext: 'Čitaj u kontekstu',
    listenOn: 'Slušaj od ovog ajeta',
    previous: 'Prethodni ajet',
    next: 'Sljedeći ajet',
    wordsTitle: 'Riječ po riječ',
    wordsHint: 'Svaka riječ ajeta s izgovorom i značenjem. Dodirni riječ i vidi koliko se puta pojavljuje u Kur’anu.',
    wordsSource: 'Izgovor i značenja riječi: Quran.com.',
    wordsSourceBs: 'Izgovor i engleska značenja riječi: Quran.com. Bosanska značenja su automatski prevedena i usklađena s Korkutovim prijevodom ajeta.',
    relatedTitle: 'Povezani ajeti',
    relatedHint: 'Ajeti iz drugih dijelova Kur’ana koji govore o istoj temi.',
    aboutSurah: 'O ovoj suri',
  },
  settings: {
    title: 'Postavke',
    translation: 'Prijevod',
    both: 'Oba',
    none: 'Bez',
    arabicFont: 'Arapsko pismo',
    arabicSize: 'Veličina arapskog teksta',
    sizeStep: 'Veličina {n}',
    wordStudy: 'Izučavanje riječi',
    wordStudyHint: 'Dodir na arapsku riječ pokazuje koliko je puta u Kur’anu.',
  },
  player: {
    label: 'Kur’an player',
    play: 'Pusti',
    pause: 'Pauziraj',
    previous: 'Prethodni ajet',
    next: 'Sljedeći ajet',
    stop: 'Zaustavi i zatvori',
    expand: 'Otvori player',
    collapse: 'Smanji player',
    nowPlaying: 'Trenutno se uči',
    openSurah: 'Otvori suru',
    seek: 'Pozicija u ajetu',
    failed: 'Audio se nije učitao. Provjeri internet i pokušaj ponovo.',
    reciter: 'Učač',
    repeatAll: 'Ponovi sve',
    ayahRepeat: 'Ponovi svaki ajet: {n}',
    repeatRound: '{n}. put',
    volume: 'Jačina zvuka',
    sleep: 'Tajmer za spavanje',
    sleepMinutes: 'Za {n} minuta',
    sleepEnd: 'Na kraju sure',
    sleepOff: 'Isključi tajmer',
    tabText: 'Tekst',
    ayahOf: 'ajet {ayah} od {total}',
    backToCurrent: 'Na ajet koji se uči',
    speed: 'Brzina',
    follow: 'Prati ajet koji se uči',
    followHint: 'Dok sura svira, stranica sama skrola do ajeta koji se uči i označi ga.',
  },
  peek: {
    title: 'Riječ {word} u Kur’anu',
    eyebrow: 'Ova riječ u Kur’anu',
    exact: 'Tačno ovaj oblik',
    inside: 'Unutar riječi',
    spread: 'U {ayahs} ajeta, kroz {surahs} sura.',
    open: 'Sva pojavljivanja',
  },
  tafsir: {
    nav: 'Tefsir',
    cta: 'Otvori tefsir',
    teaser: 'Šta ajet znači? Objašnjenje svakog ajeta iz tefsira El-Muhtesar, na bosanskom, engleskom, francuskom i u arapskom originalu, s izvorom i citatom za tvoje izučavanje.',
    eyebrow: 'Tumačenje Kur’ana',
    title: 'Tefsir Kur’ana',
    intro:
      'Objašnjenje svakog od 6.236 ajeta iz tefsira El-Muhtesar, na bosanskom, engleskom, francuskom i u arapskom originalu. Čitaj tefsir sure po suru, uporedi ga s originalom i pretraži šta je rečeno o bilo kojoj temi.',
    facts: { ayahs: 'ajeta s objašnjenjem', langs: 'jezika: bosanski, engleski, francuski, holandski, arapski', surahs: 'sura' },
    surahsTitle: 'Tefsir po surama',
    surahsHint: 'Odaberi suru: svaki ajet na arapskom, s prijevodom i objašnjenjem ispod.',
    aboutTitle: 'O tefsiru El-Muhtesar',
    about: [
      'El-Muhtesar fi tefsiril-Kur’anil-Kerim (Skraćeni tefsir Plemenitog Kur’ana) priredio je Tefsir centar za kur’anske studije. Svaki ajet objašnjen je kratko i jasno, bez dugih rasprava, pa je pogodan i za svakodnevno čitanje i za ozbiljno izučavanje.',
      'Original je napisan na arapskom; bosanski, engleski i francuski tekst su prijevodi tog originala. Zato uz svaki ajet možeš otvoriti arapski original i uporediti ga s prijevodom.',
    ],
    methodTitle: 'Kako je ovdje objavljen',
    method: [
      'Tekst je objavljen onako kako ga je izdao izvor, bez izmjena i skraćivanja.',
      'Uz svaki tekst navedeni su naslov, autor, izdanje i datum preuzimanja, a dugme „Citiraj“ daje gotov citat s linkom.',
      'Tefsir se redovno usklađuje s najnovijom verzijom koju objavljuje QuranEnc.com.',
    ],
    langLabel: 'Jezik tefsira',
    langs: { bs: 'Bosanski', en: 'English', fr: 'Français', nl: 'Nederlands', ar: 'العربية' },
    sameAs: 'Vidi objašnjenje uz {n}. ajet.',
    retold: 'Savremeno prepričavanje po klasičnim učenjacima, a ne doslovan prijevod',
    translationOf: 'Prijevod s arapskog originala',
    original: 'Arapski original',
    label: 'Tefsir',
    ayahTitle: 'Tefsir ajeta',
    ayahHint: 'Šta ovaj ajet znači: objašnjenje iz tefsira El-Muhtesar.',
    wholeSurah: 'Tefsir cijele sure',
    readSurah: 'Čitaj suru',
    show: 'Tefsir',
    hide: 'Sakrij tefsir',
    toggle: 'Tefsir ajeta {ref}',
    inReader: 'Tefsir ispod svakog ajeta',
    inReaderHint: 'Kratko objašnjenje ispod svakog ajeta. Dugme „Tefsir“ kod ajeta otvara ga i pojedinačno.',
    showAyah: 'Ajet i prijevod',
    ayahIndex: 'Ajeti',
    goToAyah: 'Idi na ajet {n}',
    source: 'Izvor',
    sourceLine: '{title} — {author}. {publisher}, izdanje „{edition}“, preuzeto {date}',
    cite: 'Citiraj',
    cited: 'Citat kopiran',
    refAyah: 'ajeta {key}',
    refSurah: 'sure {name}',
    citation: '{title} ({author}), tumačenje {ref}. {publisher}, izdanje „{edition}“, preuzeto {date} {url}',
    unavailable: 'Tefsir na ovom jeziku još nije dostupan.',
    searchTitle: 'Pretraži tefsir',
    searchLabel: 'Pretraži tefsir',
    searchPlaceholder: 'Tema ili riječ, npr. strpljenje, roditelji, Sudnji dan',
    searchHint: 'Pretražuje objašnjenja, a ne samo tekst ajeta: nađi šta tefsir kaže o nekoj temi.',
    resultCount: 'Nijedan ajet nema „{q}“ u tefsiru | {n} ajet ima „{q}“ u tefsiru | {n} ajeta ima „{q}“ u tefsiru',
    previous: 'Prethodna sura',
    next: 'Sljedeća sura',
  },
  opinions: {
    title: "Šta su učenjaci rekli",
    searchHint: "Odgovori učenjaka ehli-sunneta, po riječima i po značenju, svaki uz link na izvor.",
    ayahHint: "Odgovori koji navode ovaj ajet.",
    none: "Nema odgovora.",
    scholars: "Učenjaci",
    citedAyat: "Navedeni ajeti:",
    source: "Pročitaj na izvoru: {source}",
    inLanguage: "Dostupno na jeziku: {language}",
  },
  search: {
    title: 'Pretraga Kur’ana',
    label: 'Pretraži Kur’an',
    placeholder: 'Riječ, sura ili ajet (npr. milost, Jasin, 2:255)',
    submit: 'Traži',
    suggestions: 'Prijedlozi',
    jump: 'Idi na ajet {ref}',
    allResults: 'Svi rezultati za „{q}“',
    countWord: 'Koliko puta se spominje „{q}“?',
    modeLabel: 'Način pretrage',
    byWords: 'Po riječima',
    byMeaning: 'Po značenju',
    byScholars: "Učenjaci",
    byTafsir: 'U tefsiru',
    meaningHint: 'Opiši temu svojim riječima, npr. „ajeti o strpljenju u iskušenju“. AI pronalazi ajete po smislu, ne po riječima.',
    meaningTooShort: 'Napiši barem tri slova.',
    meaningError: 'Pretraga po značenju trenutno nije dostupna. Pokušaj pretragu po riječima.',
    resultCount: 'Nema ajeta za „{q}“ | {n} ajet za „{q}“ | {n} ajeta za „{q}“',
    took: '{ms} ms',
    aiLabel: 'Vještačka inteligencija',
    aiWorking: 'AI pretražuje Kur’an po značenju…',
    aiFound: 'AI nije pronašao ajet za ovo pitanje | AI je pronašao {n} ajet po značenju | AI je pronašao {n} ajeta po značenju',
    emptyTitle: 'Šta možeš pretraživati',
    tips: [
      'Riječ na bosanskom, engleskom ili arapskom: milost, mercy, رحمة',
      'Ime sure: Kehf, Jasin, Rahman',
      'Tačan ajet: 2:255 ili 36 1',
      'Temu po značenju: prebaci na „Po značenju“',
    ],
  },
  words: {
    title: 'Kur’an u brojevima',
    subtitle:
      'Koliko puta se neka riječ pojavljuje u Kur’anu, u kojim surama, mekanskim ili medinskim? Upiši riječ ili uporedi dvije, jednim klikom.',
    tryOne: 'Probaj jedan primjer:',
    examples: 'Primjeri',
    inputLabel: 'Riječ za brojanje',
    placeholder: 'Riječ (npr. milost, الله, day)',
    compareLabel: 'Riječ za poređenje',
    comparePlaceholder: 'Druga riječ za poređenje',
    wordA: 'Prva riječ',
    wordB: 'Druga riječ',
    addCompare: 'Uporedi s drugom riječi',
    removeCompare: 'Ukloni poređenje',
    count: 'Prebroji',
    langLabel: 'Jezik teksta',
    langBs: 'Bosanski',
    langEn: 'English',
    arabicDetected: 'Brojim u arapskom tekstu',
    modeLabel: 'Kako se riječ poklapa',
    modeWord: 'Cijela riječ',
    modePrefix: 'Počinje s',
    modeContains: 'Sadrži',
    modeHint: {
      word: 'Broji samo tačno tu riječ: „dan“ ne broji „dana“.',
      prefix: 'Broji sve riječi koje počinju tako: „strplj“ broji strpljenje, strpljivi, strpljivo… Najbolje za bosanski.',
      contains: 'Broji riječi koje sadrže upisano: arapsko „الله“ broji i „والله“, „بالله“…',
    },
    occurrences: '{n} put | {n} puta',
    inAyahs: 'u {ayahs} ajeta, {surahs} sura',
    revelationSplit: 'Mekanske sure {meccan}%, medinske {medinan}%',
    firstSeen: 'Prvi put',
    lastSeen: 'Posljednji put',
    topSurahs: 'Najviše u surama',
    equal: '„{a}“ i „{b}“ spominju se jednako, po {n} puta.',
    nearlyEqual: '„{a}“ i „{b}“ spominju se gotovo jednako: {x} i {y} puta.',
    ratio: '„{more}“ se spominje {ratio}× više od „{less}“.',
    chartTitle: 'Raspodjela kroz 114 sura',
    chartHint: 'Svaka kolona je jedna sura, redom kao u mushafu. Klikni za detalje.',
    chartLabel: 'Broj pojavljivanja po surama',
    chartCaption: 'Stupčasti grafikon: po jedna kolona za svaku od 114 sura, visina je broj pojavljivanja.',
    openSurah: 'Otvori suru',
    noneTitle: 'Nema pojavljivanja',
    noneBody: 'Prijevodi isti pojam često kazuju drugim riječima: Korkut, recimo, dunjaluk prevodi kao „ovaj svijet“. Probaj „Počinje s“ ili „Sadrži“, sinonim, ili arapsku riječ, jer je arapski tekst mjerodavan.',
    ayahsTitle: 'Ajeti',
    method:
      'Brojimo oblike riječi u tekstu, bez harekata. Arapski tekst je mjerodavan; prijevodi koriste različite riječi za isti pojam, pa se njihovi brojevi razlikuju od arapskih.',
  },
  grammar: {
    title: 'Gramatika',
    root: 'Korijen',
    lemma: 'Osnovni oblik',
    parts: 'Dijelovi riječi',
    noRoot: 'Čestice i zamjenice nemaju korijen.',
    rootCount: '{n}× u Kur’anu',
    allOfRoot: 'Sve riječi korijena',
    person: '{n}. lice',
    gender: { M: 'muški rod', F: 'ženski rod' },
    number: { S: 'jednina', D: 'dvojina', P: 'množina' },
    form: 'glagolska vrsta {n}',
    passive: 'pasiv',
    definite: 'određen (s ٱل)',
    indefinite: 'neodređen',
    family: 'iz grupe „{word}“',
    tense: { PERF: 'perfekt (prošlo)', IMPF: 'imperfekt (sadašnje/buduće)', IMPV: 'imperativ' },
    case: { NOM: 'nominativ', ACC: 'akuzativ', GEN: 'genitiv' },
    mood: { IND: 'indikativ', SUBJ: 'subjunktiv', JUS: 'džusiv' },
    class: {
      V: 'glagol',
      N: 'imenica',
      PN: 'vlastito ime',
      ADJ: 'pridjev',
      ACT_PCPL: 'aktivni particip',
      PASS_PCPL: 'pasivni particip',
      VN: 'glagolska imenica (masdar)',
      PRON: 'zamjenica',
      DEM: 'pokazna zamjenica',
      REL: 'odnosna zamjenica',
      T: 'prilog vremena',
      LOC: 'prilog mjesta',
      NV: 'glagolski uzvik',
      P: 'čestica',
    },
    particle: {
      DET: 'određeni član',
      CONJ: 'veznik',
      REM: 'nastavna čestica',
      P: 'prijedlog',
      NEG: 'negacija',
      EMPH: 'čestica naglaska',
      INTG: 'upitna čestica',
      VOC: 'vokativna čestica',
      FUT: 'čestica budućnosti',
      CERT: 'čestica izvjesnosti',
      RSLT: 'čestica posljedice',
      CAUS: 'uzročna čestica',
      SUB: 'zavisni veznik',
      COND: 'uslovna čestica',
      RES: 'čestica ograničenja',
      PRP: 'čestica svrhe',
      CIRC: 'čestica stanja',
      EXP: 'čestica izuzetka',
      PREV: 'sprečavajuća čestica',
      PRO: 'čestica zabrane',
      RET: 'čestica ispravke',
      SUP: 'dodatna čestica',
      SUR: 'čestica iznenađenja',
      EXH: 'čestica podsticaja',
      EXL: 'čestica objašnjenja',
      EQ: 'čestica izjednačenja',
      AMD: 'čestica dopune',
      ANS: 'čestica odgovora',
      AVR: 'čestica odvraćanja',
      COM: 'čestica pratnje',
      INC: 'početna čestica',
      INT: 'čestica tumačenja',
      INL: 'kur’anska početna slova',
      ATT: 'čestica pažnje',
      DIST: 'oznaka udaljenosti',
      ADDR: 'oznaka obraćanja',
      ACC: 'čestica akuzativa',
    },
  },
  roots: {
    nav: 'Korijeni',
    eyebrow: 'Rječnik Kur’ana',
    title: 'Korijeni kur’anskih riječi',
    subtitle:
      'Gotovo svaka arapska riječ izrasta iz korijena od tri ili četiri slova. Iz korijena صبر nastaju strpljenje, strpljiv i strpjeti se. Odaberi korijen i prati jedan pojam kroz cijeli Kur’an.',
    factRoots: 'korijena',
    factLemmas: 'osnovnih oblika riječi',
    factWords: 'riječi s gramatikom',
    lettersLabel: 'Korijeni po prvom slovu',
    searchLabel: 'Pretraži korijene',
    searchPlaceholder: 'Korijen ili značenje (npr. رحم, znanje, mercy)',
    count: '{n} korijena',
    showing: 'Prikazano {shown} od {total}',
    none: 'Nijedan korijen ne odgovara pretrazi.',
    showMore: 'Prikaži još',
    sortLabel: 'Poredaj',
    sortFrequent: 'Najčešći',
    sortAlpha: 'Abecedno',
    occurrences: '{n}× u Kur’anu',
    words: '{n} riječ | {n} riječi',
    pageTitle: 'Korijen {root}',
    pageSubtitle: 'Sve riječi izvedene iz ovog korijena, gdje se javljaju kroz Kur’an i svi ajeti u kojima se nalaze.',
    lemmasTitle: 'Riječi iz ovog korijena',
    lemmasHint: 'Klikni riječ da vidiš samo njene ajete.',
    allLemmas: 'Sve riječi',
    lemmaCol: 'Riječ',
    classCol: 'Vrsta',
    meaningCol: 'Značenje',
    countCol: 'Puta',
    filtered: 'Prikazano samo: {lemma}',
    clearFilter: 'Prikaži cijeli korijen',
    chartTitle: 'Raspodjela kroz 114 sura',
    ayahsTitle: 'Ajeti',
    back: 'Svi korijeni',
    notFound: 'Ovaj korijen ne postoji u Kur’anu.',
    whatTitle: 'Šta je korijen?',
    whatBody:
      'U arapskom jeziku značenje nosi korijen, obično tri suglasnika, a vokali i dodaci grade riječi. Iz korijena كتب nastaju kataba (pisao je), kitāb (knjiga), kātib (pisar) i maktūb (napisano). Kad pratiš korijen, vidiš kako Kur’an jedan pojam razvija kroz različite riječi.',
    methodTitle: 'Izvor i metoda',
    methodBody:
      'Korijen, osnovni oblik i gramatika svake riječi preuzeti su iz Quranic Arabic Corpusa (Univerzitet u Leedsu), u kojem je svaka od 77.429 riječi ručno označena. Značenja korijena i riječi sažeta su pomoću AI-ja iz prijevoda riječi u svakom ajetu i služe kao orijentir, ne kao rječnik.',
    source: 'Gramatika: Quranic Arabic Corpus 0.4, Kais Dukes, Univerzitet u Leedsu (GNU GPL), s ispravkama projekta mustafa0x/quran-morphology.',
    aiNote: 'Značenja sažeta pomoću AI-ja',
    teaser: 'Gotovo svaka arapska riječ izrasta iz korijena od tri slova. Prati korijen kroz cijeli Kur’an: sve riječi koje iz njega nastaju, njihova značenja i svi ajeti.',
    cta: 'Istraži korijene',
  },
  translations: {
    eyebrow: 'Više prijevoda',
    title: 'Uporedni prijevodi',
    hint: 'Isti ajet u šest prijevoda. Odaberi jedan kao osnovu i vidjet ćeš gdje ga drugi prevode drugačije.',
    compareWith: 'Označi razlike u odnosu na',
    compareOff: 'Bez poređenja',
    isBase: 'osnova poređenja',
    alike: '{n}% istih riječi',
    legendAdded: 'drugačije',
    legendRemoved: 'izostavljeno',
    legendNote: 'Porede se prijevodi na istom jeziku, riječ po riječ.',
    footnote: 'Napomena {n}',
    notes: 'Napomene prevodioca ({n})',
    extra: 'Dodatni prijevodi ispod ajeta',
    extraHint: 'Uz Korkuta i Saheeh International, s QuranEnc.com.',
    lang: { bs: 'Bosanski', en: 'Engleski', de: 'Njemački', nl: 'Holandski', fr: 'Francuski' },
    names: {
      'bubenheim': 'Bubenheim i Elyas (njemački)',
      'rowwad-de': 'Rowwad (njemački)',
      'rowwad-nl': 'Rowwad (holandski)',
      rashid: 'Rachid Maach (francuski)',
      'noor-fr': 'Noor International (francuski)',
      korkut: 'Besim Korkut',
      mehanovic: 'Muhamed Mehanović',
      'rowwad-bs': 'Rowwad (bosanski)',
      saheeh: 'Saheeh International',
      'hilali-khan': 'Hilali i Khan',
      'rowwad-en': 'Rowwad (engleski)',
    },
  },
  chronology: {
    nav: 'Hronologija',
    eyebrow: 'Hronologija objave',
    title: 'Kur’an redom kojim je objavljivan',
    subtitle:
      'Kur’an je objavljivan postepeno, oko 23 godine, a u mushafu sure ne stoje redom kojim su objavljene. Ovdje ih vidiš onako kako su silazile: od prvih ajeta sure El-Alek u Mekki do posljednjih sura u Medini.',
    factYears: 'godine objave',
    factMeccan: 'mekanskih sura',
    factMedinan: 'medinskih sura',
    timelineTitle: 'Sve sure redom objave',
    timelineHint: 'Svaka kolona je jedna sura, a visina je njena dužina u riječima. Klikni kolonu da otvoriš suru.',
    timelineInsight:
      'Prve objavljene sure su kratke, ritmične i snažne. Kako objava odmiče, sure postaju sve duže, a nakon Hidžre u Medinu dolaze najduže sure, s propisima za zajednicu.',
    barHint: 'Visina = broj riječi',
    hijra: 'Hidžra (622.)',
    revealedNth: '{n}. po redu objave',
    ayahs: 'Ajeta',
    words: 'Riječi',
    ayahCount: '{n} ajeta',
    chartLabel: 'Stupčasti grafikon: 114 sura poredanih po redu objave, visina je broj riječi, boja je mekanski ili medinski period.',
    chartCaption: 'Sure lijevo prema desno redom kojim su objavljene; isprekidana linija je Hidžra.',
    compareTitle: 'Mekanske i medinske sure',
    compareSubtitle: 'Isti Kur’an, dva perioda: trinaest godina poziva u Mekki i deset godina izgradnje zajednice u Medini. Razlika se vidi i u brojkama.',
    metric: {
      surahs: 'Sura',
      ayahs: 'Ajeta',
      words: 'Riječi',
      wordsPerAyah: 'Riječi po ajetu (prosjek)',
      ayahsPerSurah: 'Ajeta po suri (prosjek)',
    },
    lengthInsight: 'Mekanski ajet ima u prosjeku {meccan} riječi, a medinski {medinan}. Kratki, sažeti ajeti Mekke postaju u Medini duži i detaljniji, jer donose propise.',
    distinctive: {
      meccan: 'Karakteristično za mekanske sure',
      medinan: 'Karakteristično za medinske sure',
    },
    distinctiveHint: 'Korijeni koje jedan period koristi znatno više od drugog. Brojevi: mekanske · medinske.',
    methodNote:
      'Metoda: log-odds omjer s informativnim Dirichletovim priorom (Monroe, Colaresi i Quinn, 2008), izražen kao z-vrijednost. Ne mjeri samo koliko je riječ česta, nego koliko je neočekivano česta u jednom periodu, a oprezna je s rijetkim riječima. Korijeni iz Quranic Arabic Corpusa.',
    listTitle: 'Popis sura po redu objave',
    period: { meccan: 'Mekanski period · 1.–86.', medinan: 'Medinski period · 87.–114.' },
    aboutTitle: 'O redoslijedu objave',
    about1:
      'Redoslijed je onaj iz standardnog egipatskog izdanja mushafa (El-Ezher, 1924), koji se oslanja na predaje od ashaba i tabiina. To je najčešće navođeni redoslijed, ali ne i jedini: učenjaci se razilaze oko mjesta nekih sura, a neke sure sadrže ajete iz oba perioda.',
    about2:
      'Mekanskim se smatraju sure objavljene prije Hidžre, a medinskim one poslije nje, bez obzira na mjesto gdje je ajet objavljen. Godine su približne: objava je počela oko 610., Hidžra je bila 622., a posljednji ajeti objavljeni su 632. godine.',
    source: 'Izvori: red objave i podjela na mekanske i medinske sure, Tanzil Project (tanzil.net, CC BY 3.0); riječi i korijeni, Quranic Arabic Corpus 0.4 (corpus.quran.com).',
    teaser: 'Sure redom kojim su objavljivane, na vremenskoj liniji, i po čemu se mekanske i medinske sure razlikuju: dužinom, ritmom i riječima.',
    cta: 'Otvori hronologiju',
    mushafOrder: 'Redom u mushafu',
    revelationOrder: 'Redom objave',
    orderLabel: 'Redoslijed sura',
  },
  app: {
    available: 'Besplatno na',
    eyebrow: 'Deenly aplikacija',
    title: 'Ponesi Kur’an sa sobom',
    subtitle:
      'Na webu čitaš i izučavaš. U aplikaciji Kur’an živi s tobom: uči napamet uz AI koji sluša tvoje učenje, slušaj bez interneta i nikad ne izgubi mjesto gdje si stao.',
    features: [
      { icon: 'solar:microphone-3-linear', title: 'Hifz AI', body: 'Prouči naglas, a aplikacija označi svaku riječ kao tačnu ili netačnu.' },
      { icon: 'solar:download-minimalistic-linear', title: 'Audio bez interneta', body: 'Preuzmi sure i slušaj bilo gdje.' },
      { icon: 'solar:bell-linear', title: 'Podsjetnici', body: 'Nježan podsjetnik ujutro i navečer, s ajetom dana.' },
      { icon: 'solar:cup-star-linear', title: 'Hatma i nagrade', body: 'Plan čitanja i prekretnice koje te motivišu.' },
    ],
  },
  footer: {
    title: 'Kur’an na Deenly',
    body: 'Kur’an je otvoren za svakoga, besplatno i bez prijave. Tekst i prijevodi su preuzeti iz provjerenih izvora navedenih ispod.',
    arabic: 'Arapski tekst',
    audio: 'Audio',
    bs: 'Bosanski prijevod',
    en: 'Engleski prijevod',
    links: 'Linkovi',
  },
};
